import React from "react"
import { BsStar, BsStarFill } from "react-icons/bs";

export function StarsRate(props){
    const rateValue = props.rateValue ? props.rateValue : 0;
    const rating = [1, 2, 3, 4, 5];

    return (
        <>
            {
                rating.map((r, index) => {
                    return rateValue >= r ? <BsStarFill key={index} color="#FF961B" /> : <BsStar key={index} color="#FF961B" />
                })
            }
        </>
    );
}